// Body of the Oscar single-page checkout view: the `#checkout-app` SPA mount
// point inside the capped-width page column.
import React from "react";

import { CheckoutApp } from "../../apps/checkout/CheckoutApp";

import styles from "./index.module.scss";

export const CheckoutPageBody = (): React.JSX.Element => (
    <div className="l-capped-width">
        <div id="checkout-app" className={styles.checkoutAppContainer}>
            <CheckoutApp />
        </div>
    </div>
);
